<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Title</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="'required'"
                name="promotitle"
                class="w-full"
                v-model="form.promotitle"
                :maxlength="200"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('promotitle')"
                >{{ errors.first("promotitle") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Description</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-textarea
                v-validate="'required'"
                name="promodesc"
                class="w-full"
                v-model="form.promodesc"
                :maxlength="200"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('promodesc')"
                >{{ errors.first("promodesc") }}</span
              >
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Discount</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3">
                  <vs-input
                    v-validate="'required'"
                    name="discvalue"
                    v-model="form.discvalue"
                    style="width:120px;"
                    onkeypress="return /^[0-9]*\.?[0-9]*$/i.test(event.key)"
                    onpaste="return false"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('discvalue')">
                    {{ errors.first("discvalue") }}
                  </span>
                </div>

                <div class="vx-col sm:w-2/3">
                  <ul style="display:inline-block; padding-top:15px;">
                    <li style="display:inline-block">
                      <vs-radio
                        v-model="form.disctype"
                        vs-value="percent"
                        class="mx-3"
                        >Percent (%)</vs-radio
                      >
                    </li>
                    <li style="display:inline-block">
                      <vs-radio
                        v-model="form.disctype"
                        vs-value="amount"
                        class="mx-3"
                        >Baht</vs-radio
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Discount from</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul style="display:inline-block; padding-top:15px;">
                  <li style="display:inline-block">
                    <vs-radio
                      v-model="form.discfrom"
                      vs-value="fullprice"
                      class="mx-3"
                      >Full Price</vs-radio
                    >
                  </li>
                  <li style="display:inline-block">
                    <vs-radio
                      v-model="form.discfrom"
                      vs-value="currentprice"
                      class="mx-3"
                      >Current Price</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div> -->

          <section>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Discount On</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio v-model="form.disclevel" vs-value="1"
                      >All</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio v-model="form.disclevel" vs-value="2"
                      >Selective Tickets</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div v-if="form.disclevel == 2" class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                Select the tickets the discount is applicable to
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="centerx">
                  <li
                    v-for="(item, i) in productList"
                    :key="i"
                    style="margin:12px 0;"
                  >
                    <vs-checkbox v-model="item.selected">{{
                      item.pro_name
                    }}</vs-checkbox>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Period</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <flat-pickr
                :config="configdateTimePicker"
                v-model="form.date_start"
                placeholder="Date Time Start"
              />
              <span class="mx-4">to</span>
              <flat-pickr
                :config="configdateTimePicker"
                v-model="form.date_end"
                placeholder="Date Time End"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Quantity</span>
              <div style="font-size:0.75rem; color:#aaa;">
                Number of times this can be used
              </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="{
                  required: true,
                  min_value: 1
                }"
                name="qty"
                class="w-full"
                v-model="form.qty"
                onkeypress="return /[0-9]/i.test(event.key)"
                onpaste="return false"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Note attached to order (Internal use)</span>
              <div style="font-size:0.75rem; color:#aaa;">Internal use</div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-textarea
                v-validate
                name="promonote"
                class="w-full"
                v-model="form.promonote"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('promonote')"
                >{{ errors.first("promonote") }}</span
              >
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Status</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <ul class="demo-alignment">
                <li>
                  <vs-radio v-model="form.promo_status" vs-value="1"
                    >Enabled</vs-radio
                  >
                </li>
                <li>
                  <vs-radio v-model="form.promo_status" vs-value="0"
                    >Disabled</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Weight</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="{}"
                name="weight"
                class="w-full"
                v-model="form.weight"
              />
              <span class="text-danger text-sm" v-show="errors.has('weight')">{{
                errors.first("weight")
              }}</span>
            </div>
          </div>

          <div style="height:30px;"></div>
          <div class="vx-row pt-2 mt-0">
            <div class="vx-col w-full ml-auto">
              <vs-button class="mr-3 mb-2" @click="validateForm"
                >Save
              </vs-button>

              <vs-button class="mr-3 mb-2" type="border" @click="cancel()"
                >Cancel
              </vs-button>
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>
<script>
// import { Validator } from "vee-validate";
import moment from "moment";
import { mapState } from "vuex";

import Service from "@/services";
import { timezones } from "@/utils/Timezones";

import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

// const dict = {
//   form: {
//     promotitle: {
//       required: "Please enter an event name"
//     },
//     promoshortname: {
//       required: "Please enter a short title"
//     },
//   }
// };

// // register custom messages
// Validator.localize("en", dict);

export default {
  components: {
    VxAutoSuggest,
    flatPickr
  },
  props: ["promocode_id"],
  computed: {
    ...mapState({
      accessToken: state => {
        return state.Auth.accessToken;
      },
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  data() {
    return {
      productList: [],
      form: {
        e: null,
        promotitle: null,
        promo_type: "std",
        promodesc: null,
        discfrom: "fullprice",
        disctype: "percent",
        discvalue: null,
        disclevel: 1,
        date_start: null,
        date_end: null,
        pccode: null,
        promonote: null,
        promo_status: 1,
        selective: []
      },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d-m-Y H:i",
        maxDate: null
      },
    };
  },
  watch: {
    "form.pccode": function(newVal, oldVal) {
      this.form.pccode = newVal.toUpperCase();
    }
  },
  created() {
    this.form.e = this.e;

    let data = {
      e: this.e
    };

    let params = Object.keys(data)
      .map(key => key + "=" + data[key])
      .join("&");

    Service.Product.gets(params).then(res => {
      this.productList = res.data.rows.map(item => {
        return {
          product_id: item.product_id,
          pro_name: item.pro_name,
          selected: false
        };
      });
    });
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submit();
        }
      });
    },
    cancel() {
      this.$router.push("/promotions?s=" + this.s + "&e=" + this.e);
    },
    submit() {
      this.form.e = this.e;
      this.form.selective = this.productList.filter(x => x.selected == true);

      this.$vs.loading();

      Service.Bootsale.addPromo(this.form)
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Add new promotion completed.",
              color: "success"
            });
            this.$router.push("/promotions?s=" + this.s + "&e=" + this.e);
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + error.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    onEndChange(selectedDates, dateStr, instance) {
      this.configs.configdateTimePicker.maxDate = dateStr
    },
    onStartChange(selectedDates, dateStr, instance) {
      this.configs.configdateTimePickerEnd.minDate = dateStr
    },
  }
};
</script>
